<script lang="ts">
  import RequiredBadge from '$lib/components/common/badges/RequiredBadge.svelte';
  import OptionalBadge from '$lib/components/common/badges/OptionalBadge.svelte';
  import { showToast } from '$lib/helpers/toastrHelper';
  import { fetchWithAuth } from '$lib/utils/http/httpUtil';

  export let selectedEntityId: string;
  export let clientId: string;
  export let isRequired = true;
  export let isDisabled = false;
  export let allowCreateNew = false;
  export let apiEndpoint = '/api/support-tools/clients';

  let entities: Array<{ id: number; name: string }> = [];
  let isLoading = false;

  export async function loadEntities(clientId: string) {
    if (!clientId) {
      entities = [];
      selectedEntityId = '';
      return;
    }

    // Clear selection when loading new entities
    selectedEntityId = '';
    isLoading = true;
    try {
      const response = await fetchWithAuth(`${apiEndpoint}/${clientId}/entities`);
      const result = await response.json();
      if (Array.isArray(result)) {
        entities = result;
        console.log('Entities loaded:', entities.length, entities);
        // Auto-select if only one entity available
        if (entities.length === 1) {
          selectedEntityId = entities[0].id.toString();
          console.log('Auto-selecting entity:', selectedEntityId);
        }
      }
    } catch {
      showToast({
        title: 'Error',
        message: 'Failed to load entities',
        type: 'error',
      });
    } finally {
      isLoading = false;
    }
  }

  $: if (clientId) {
    console.log('EntitySelector: clientId changed to', clientId);
    loadEntities(clientId);
  } else {
    entities = [];
    selectedEntityId = '';
  }
</script>

<div>
  <label for="entity-select" class="mb-2 flex items-center gap-2 text-sm font-medium">
    Entity
    {#if isRequired}
      <RequiredBadge />
    {:else}
      <OptionalBadge />
      {#if allowCreateNew}
        <span class="text-xs font-normal text-gray-500">- Leave empty to create new entity</span>
      {/if}
    {/if}
  </label>
  <select
    id="entity-select"
    bind:value={selectedEntityId}
    class="w-full rounded-md border px-3 py-2 transition-all focus:outline-none focus:ring-2 focus:ring-primary-500"
    class:border-gray-300={selectedEntityId || !isRequired}
    class:border-primary-200={!selectedEntityId && isRequired}
    disabled={isDisabled || isLoading}
  >
    {#if entities.length !== 1}
      <option value="">
        {#if allowCreateNew}
          Select an entity or leave empty to create new...
        {:else}
          Select an entity...
        {/if}
      </option>
    {/if}
    {#each entities as entity}
      <option value={entity.id.toString()}>{entity.name} (ID: {entity.id})</option>
    {/each}
  </select>
</div>
